import { ActionType, createReducer } from 'typesafe-actions';
import { combineReducers } from 'redux';
import {
  cancelDislikeForReview,
  cancelLikeForReview,
  changeDislikeToLikeForReview,
  changeLikeToDislikeForReview,
  resetReviewsOpinionsRecords,
  setDislikeForReview,
  setLikeForReview,
  setVoterId,
} from '../actions';
import { ViewsModels } from '../types';

export type ReviewsLikeDislikeActions =
  | ActionType<typeof resetReviewsOpinionsRecords>
  | ActionType<typeof setLikeForReview>
  | ActionType<typeof cancelLikeForReview>
  | ActionType<typeof setDislikeForReview>
  | ActionType<typeof cancelDislikeForReview>
  | ActionType<typeof changeLikeToDislikeForReview>
  | ActionType<typeof changeDislikeToLikeForReview>;

export const reviewsLikeDislikeReducer = createReducer<
  ViewsModels.ReviewsOpinionRecords[],
  ReviewsLikeDislikeActions
>([])
  .handleAction(resetReviewsOpinionsRecords, (_, { payload }) => payload)
  .handleAction([setLikeForReview, changeDislikeToLikeForReview], (state, { payload }) => {
    const result = state.filter((r) => r.reviewId !== payload);
    result.push({ reviewId: payload, opinion: 'LIKE' });

    return result;
  })
  .handleAction([setDislikeForReview, changeLikeToDislikeForReview], (state, { payload }) => {
    const result = state.filter((r) => r.reviewId !== payload);
    result.push({ reviewId: payload, opinion: 'DISLIKE' });

    return result;
  })
  .handleAction(cancelLikeForReview, (state, { payload }) => {
    return state.filter((r) => !(r.reviewId === payload && r.opinion === 'LIKE'));
  })
  .handleAction(cancelDislikeForReview, (state, { payload }) => {
    return state.filter((r) => !(r.reviewId === payload && r.opinion === 'DISLIKE'));
  });

export type LikeDislikeVoterIdActions = ActionType<typeof setVoterId>;
export const likeDislikeVoterIdReducer = createReducer<string | null, LikeDislikeVoterIdActions>(
  null,
).handleAction(setVoterId, (_, { payload }) => payload);

export const likeDislikeReducer = combineReducers({
  records: reviewsLikeDislikeReducer,
  voterId: likeDislikeVoterIdReducer,
});
